module.exports = __webpack_public_path__ + "img/np_overview_2172952_000000.3470066b.svg";